import dayjs from 'dayjs'
import { TransportType } from '@/interfaces/invite'
import { Organization } from '@/interfaces/organization'
import { Participant } from '@/interfaces/participant'
import { SeasonOrganization } from '@/interfaces/seasonOrganization'
import { LinkType, ChannelType } from '@/interfaces/shopLink'
import { config } from '@/config'
import { UTMParams } from '@/interfaces/visit'

export const useShopLink = () => {
  const getBaseUrl = (type: LinkType = LinkType.SHOP) => {
    switch (type) {
      case LinkType.SHOP:
        return config.shopUrl
      case LinkType.QUICK_PAY:
        return config.quickPay.url
      default:
        throw new Error('Base url for link not found')
    }
  }

  const mapToChannelType = (type: TransportType) => {
    switch (type) {
      case TransportType.TEXT:
        return ChannelType.SMS
      default:
        return type
    }
  }

  const buildShopLink = ({
    seasonName,
    organization,
    seasonOrganization,
    participants = [],
    type = LinkType.SHOP,
    channel,
    utmParams,
  }: {
    seasonName?: string
    organization?: Organization
    seasonOrganization?: SeasonOrganization
    participants?: Pick<Participant, 'code' | 'firstName' | 'lastName'>[]
    type?: LinkType
    channel: string
    utmParams?: UTMParams
  }) => {
    const url = new URL(getBaseUrl(type))
    const maxParticipantCount = parseInt(config.maxParticipantCount, 10)
    const params: Record<string, string | null> = {
      progid: seasonName || '',
      inviteID: '',
      channelID: channel,
      school1NM: organization?.name || '',
      school1STC: '',
      school1STS: '',
      school1STSE: seasonOrganization ? dayjs(seasonOrganization.endAt).format('YYYY_MM_DD') : '',
      ...(utmParams || {}),
    }
    const length = participants.length <= maxParticipantCount ? participants.length : maxParticipantCount
    for (let i = 0; i < length; i++) {
      const participant = participants[i]
      url.searchParams.append(`student${i + 1}ID`, participant.code)
      url.searchParams.append(`student${i + 1}FNM`, participant.firstName)
      url.searchParams.append(`student${i + 1}LNM`, participant.lastName)
    }
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value || '')
    })
    return url.toString()
  }

  return {
    buildShopLink,
    mapToChannelType,
  }
}
